export default __webpack_public_path__ + "images/kieliszki_active.png";